<template>
  <b-card class="rounded-lg">
    <template #header>
      <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
        <h4 class="text-dark m-0">
          Direct Questions {{ records.length > 0 ? `(${records.length})` : '' }}
        </h4>

        <div v-if="can('presenting_questions:CanAddNew') && currentUserProfession === 'doctor'" class="d-flex align-items-center">
          <b-button size="sm" variant="link" class="p-0" @click="onAddNew">
            <feather-icon
              icon="PenToolIcon"
              size="25"
            />
          </b-button>
        </div>
      </div>
    </template>
    

    <div class="" style="height: 480px; overflow-y: scroll;">
      <b-overlay :show="loading" opacity="0.5">
        <capture-presenting-question-answers-modal
          :editing-data.sync="editingData"
          :is-add-active.sync="toggleModal"
          :consultation-data="consultationData"
          resource="presenting_questions"
          modal-title="Presenting Questions"
          @create="onCreate"
          @refetchData="fetchAllData"
        />

        <div>
          <list-table
            :records="records" 
            :columns="tableColumns"
            :current-page-number="1"
            :show-import-button="false"
            :show-export-button="false"
            :show-search="false"
            :total-records="totalRecords"
          >
            <template #cell(_id)="data">
              <div>
                <b-button v-b-toggle="`collapse-${data.item.complaint_id}`" variant="primary" class="">
                  <span>{{ data.value }}</span>
                  <!-- <feather-icon :icon="system.visible ? 'MinusCircleIcon' : 'PlusCircleIcon'" size="25" color="dodgerblue" /> -->
                </b-button>
                
                <b-collapse 
                  :id="`collapse-${data.item.complaint_id}`" 
                  class="card-body" 
                  style="border-left: 2px solid gray; margin-left: 8px; margin-top: 10px;"
                >
                  <list-table
                    :records="data.item.questions" 
                    :columns="[
                      { key: 'question', sortable: false, },
                      { key: 'answer', sortable: false, },
                      { key: 'actions', sortable: false, },
                    ]"
                    :current-page-number="1"
                    :show-import-button="false"
                    :show-export-button="false"
                    :show-search="false"
                    :total-records="data.item.questions.length"
                  >
                    <template #cell(actions)="action">
                      <div v-if="currentUserProfession === 'doctor'">
                        <b-dropdown
                          variant="link"
                          no-caret
                          :right="$store.state.appConfig.isRTL"
                        >
                          <template #button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="align-middle text-body"
                            />
                          </template>
  
                          <b-dropdown-item @click="onDelete(action.item)">
                            <feather-icon icon="Trash2Icon" />
                            <span class="align-middle ml-50">Delete</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <span v-else class="ml-2">-</span>
                    </template>

                    <template #cell(answer)="answer">
                      <span style="color: dodgerblue">{{ answer.value === true ? 'Yes' : answer.value === false ? 'No' : answer.value }}</span>
                    </template>
                  </list-table>
                </b-collapse>
              </div>
            </template>
          </list-table>
        </div>
      </b-overlay>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BRow,
  BCol,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BOverlay,
  VBToggle,
  BDropdown,
  BCollapse,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

import { get, startCase } from 'lodash';

import Ripple from 'vue-ripple-directive'
import ListTable from "@/@core/components/ListTable/ListTable.vue";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CapturePresentingQuestionAnswersModal from '@/@core/components/shared/admin/modals/CapturePresentingQuestionAnswersModal.vue';

export default {
  components: {
    BImg,
    BRow,
    BCol,
    BCard,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BOverlay,
    BDropdown,
    BCollapse,
    BDropdownItem,
    BDropdownGroup,

    ListTable,
    CapturePresentingQuestionAnswersModal
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  props: {
    consultationData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,

      editingData: null,
      toggleModal: false,
      
      records: [],
      tableColumns: [
        { key: '_id', label: 'System', sortable: false, },
        // eslint-disable-next-line no-confusing-arrow, no-nested-ternary
        // { key: 'answer', sortable: false, formatter: (val) => val === true ? 'Yes' : val === false ? 'No' : val },
        // { key: 'created', label: 'Date', sortable: false, formatter: val => `${this.formatDate(val, 'MM-yy')}`, class: 'w-10' },
        // { key: 'actions' },
      ],
    }
  },
  computed: {
    totalRecords: {
      get(){
        return this.$store.getters[`navigation/totalRecords`];
      },
      set(value){
        this.$store.commit(`navigation/UPDATE_TOTAL_RECORDS`, value)
      }
    },
  },
  created() {
    this.fetchAllData();
  },
  methods: {
    async fetchAllData() {
      try {
        this.loading = true; 

        const query = {
          page: 1,
          limit: 100,
          consultation_id: this.consultationData._id,
        }

        const request = await this.useJwt().mainService.presentingQuestions.list(query);
        const { data, pagination } = request.data;
        this.records = data;
        this.totalRecords = pagination.totalRecords
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async onCreate(form_data){
      try {
        this.loading = true;

        const { payload } = form_data;
        await this.useJwt().mainService.presentingQuestions.create(payload);
        this.fetchAllData();

        // if (save_and_proceed){
        //   this.toggleModal = false;
        //   const id = get(response, 'data.data.id');
        //   if (id){
        //     this.$router.push({
        //       params: { id },
        //       name: 'admin-consultation-details',
        //     })
        //   }
        // } else {
        //   this.toggleModal = false;
        // }
        this.toggleModal = false;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Record added successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    async onDelete(form_data){
      try {
        this.loading = true;

        await this.useJwt().mainService.presentingQuestions.delete(form_data._id, form_data.presenting_complaint_id);
        this.fetchAllData();

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: `Record deleted successfully`
          },
        });
      } catch (error){
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    onAddNew(){
      this.editingData = null;
      this.toggleModal = true;
    },
    startCase
  }
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}
</style>

<style>
.w-10 {
  width: 13% !important;
}
</style>
